var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/InputGroup/InputGroup.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable indent */
import React from "react";
import InputEssay from "../InputEssay/InputEssay";
import InputCheckbox from "../InputCheckbox/InputCheckbox";
import InputCurrency from "../InputCurrency/InputCurrency";
import InputRadio from "../InputRadio/InputRadio";
import NPSGroup from "../NPSGroup/NPSGroup";
import { questionPropType } from "../../prop-types";
import InputCheckboxGroup from "../InputCheckboxGroup/InputCheckboxGroup";
var CURRENCY = "CURRENCY";
var CHECKBOX = "CHECKBOX";
var ESSAY = "ESSAY";
var NPS = "NPS";
var InputByQuestionType = function InputByQuestionType(_ref) {
  var question = _ref.question,
    option = _ref.option,
    props = _objectWithoutProperties(_ref, ["question", "option"]);
  switch (question.type) {
    case CURRENCY:
      return /*#__PURE__*/React.createElement(InputCurrency, {
        id: question.alias,
        name: question.alias,
        validation: question.validation,
        required: true,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 21,
          columnNumber: 9
        }
      });
    case ESSAY:
      return /*#__PURE__*/React.createElement(InputEssay, {
        id: question.alias,
        name: question.alias,
        maxLength: question.validation.max,
        required: true,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 30,
          columnNumber: 9
        }
      });
    case CHECKBOX:
      return /*#__PURE__*/React.createElement(InputCheckbox, Object.assign({
        id: option.id,
        name: question.alias,
        label: option.label,
        value: option.id
      }, props, {
        required: true,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39,
          columnNumber: 9
        }
      }));
    default:
      return /*#__PURE__*/React.createElement(InputRadio, {
        id: option.id,
        name: question.alias,
        label: option.label,
        value: option.id,
        required: true,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 9
        }
      });
  }
};
var OptionInputs = function OptionInputs(props) {
  var question = props.question;
  if (question.type === "CHECKBOX") {
    return /*#__PURE__*/React.createElement(InputCheckboxGroup, Object.assign({}, props, {
      InputByQuestionType: InputByQuestionType,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 7
      }
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 5
    }
  }, question.options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(InputByQuestionType, {
      question: question,
      option: option,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 11
      }
    }));
  }));
};
var inputsForQuestion = function inputsForQuestion(question) {
  if (question.type === NPS) {
    return /*#__PURE__*/React.createElement(NPSGroup, {
      question: question,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85,
        columnNumber: 12
      }
    });
  }
  if (Array.isArray(question.options)) {
    return /*#__PURE__*/React.createElement(OptionInputs, {
      question: question,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(InputByQuestionType, {
    question: question,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 10
    }
  });
};
var InputGroup = function InputGroup(_ref2) {
  var question = _ref2.question;
  return /*#__PURE__*/React.createElement("div", {
    role: "group",
    className: "survey-InputGroup",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 3
    }
  }, inputsForQuestion(question));
};
InputGroup.propTypes = {
  question: questionPropType.isRequired
};
export { InputGroup as default };